<template>
  <div class="submain__terrenos-custom">
    <div class="line__vertical-mains"></div>
    <button-back/>
    <div v-if="locations.length > 0" class="map_filter">
      <div class="select__box box-terrenos">
        <Range class="ranges-mobile" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
        <Availables
            class="availables-mobile"
            :type="type"
            :existFilter="existFilter"
            :amountAvailables="amountAvailables"


        />
      </div>
      <div class="maphighlight__box">
          <h1 class="caption__select">
                  <span>Seleccione un terreno, clic para ver detalles</span>
                </h1>
        <map-highlight :img="img"
                       :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type"
                       :nivel="nivel"/>
        <Button :img="img" :id="id"
                :desarrollo="desarrollo" :nivel="nivel"  :levelId="levelId" :url="url"/>
        <div class="line_horizontal ranges-desk"></div>
        
      </div>
      <div class="select__box">
        <!-- <Select
            v-if="locations.length > 0 && rangeFilter.length > 0"
            :locations="locations"
            @change="changeRange"
            :rangeFilter="rangeFilter"
        /> -->
        <Availables
            class="availables-desk"
            :type="type"
            :existFilter="existFilter"
            :amountAvailables="amountAvailables"

        />
        <Range class="ranges-desk" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import MapHighlight from "../../core/MapHighlight";
import ButtonBack from "../../core/ButtonBack";
import Button from "../../core/Button.vue";
import Availables from "../../core/Availables.vue";
/* import Select from "../../core/Select.vue"; */
import Range from "../../core/Range.vue";

export default {
  name: "Main",
  components: {
    MapHighlight,
    Button,
    ButtonBack,
    Availables,
   /*  Select, */
   Range
  },
  data() {
    return {
      id: 47,
      levelId: this.$route.params.id,
      type: "terreno",
      desarrollo: "lomalta-priv",
      arrFilteredLocations: [],
      nivel: "availability",
      url: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
      micrositeUrl: "https://www.tresmarias.com.mx/lomalta/terrenos",
      privadas: {
         PRIVADA1: {
          name: 'privada1',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/lomalta/privadas/privada1.png',
          width: '649',
          id: 47, 
          levelId: this.$route.params.id,
          nivel: 'availability',
          route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
          height: '1301',
          transform: '',
          viewBox: '0 0 649 1301'
        },
        PRIVADA4: {
          name: 'privada4',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/lomalta/privadas/privada4.png',
          width: '1000',
          id: 47, 
          levelId: this.$route.params.id,
          nivel: 'availability',
          route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
          height: '1091',
          transform: '',
          viewBox: '0 0 1000 1091'
        },
        PRIVADA5: {
          name: 'privada5',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/lomalta/privadas/privada5.png',
          width: '900',
          id: 47,
          levelId: this.$route.params.id,
          nivel: 'availability',
          route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
          height: '516',
          transform: '',
          viewBox: '0 0 900 516'
        },
        PRIVADA6: {
          name: 'privada6',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/lomalta/privadas/privada6.png',
          width: '760',
          id: 47,
          levelId: this.$route.params.id,
          nivel: 'availability',
          route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
          height: '494',
          transform: '',
          viewBox: '0 0 760 494'
        },
        PRIVADA7: {
          name: 'privada7',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/lomalta/privadas/privada7.png',
          width: '700',
          id: 47,
          levelId: this.$route.params.id,
          nivel: 'availability',
          route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
          height: '574',
          transform: '',
          viewBox: '0 0 700 574'
        },
        PRIVADA8: {
          name: 'privada8',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/lomalta/privadas/privada8.png',
          width: '1000',
          id: 47,
          levelId: this.$route.params.id,
          nivel: 'availability',
          route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
          height: '1091',
          transform: '',
          viewBox: '0 0 1000 1091'
        },
      },
      //rangeFilterPrice:[1145680,2004051],
      rangeFilters:[
        { min: 92, max: 109.49 },
        { min: 112, max: 232.87 },
      ],
      rangeSliderFilterPriv1:[143,291],
      rangeFilterPricePriv1:[789140,2102521],
      rangeFilterPriv1:[
        { min: 143.21, max: 154.73 },
        { min: 157.86, max: 290.71 },
      ],
      rangeSliderFilterPriv5:[137,883],
      rangeFilterPricePriv5:[616770,1568172],
      rangeFilterPriv5:[
        { min: 137.06, max: 184.58 },
        { min: 203.60, max: 882.19 },
      ],
      rangeSliderFilterPriv6:[120,264],
      rangeFilterPricePriv6:[765072,2162586],
      rangeFilterPriv6:[
        { min: 120.80, max: 168.74 },
        { min: 175.26, max: 843.93 },
      ],
      rangeSliderFilterPriv7:[120,844],
      rangeFilterPricePriv7:[715060,2339400],
      rangeFilterPriv7:[
        { min: 120.80, max: 168.74 },
        { min: 175.26, max: 843.93 },
      ],
      rangeSliderFilterPriv8:[115,1351],
      rangeFilterPricePriv8:[576700,2445493],
      rangeFilterPriv8:[
        { min: 115.34, max: 191.35 },
        { min: 192.21, max: 1350.10 },
      ],
      rangeSliderFilterPriv4:[134,266],
      rangeFilterPricePriv4:[667440,1640900],
      rangeFilterPriv4:[
        { min: 134.61, max: 256.6 },
        { min: 192.21, max: 1350.10 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      locations: "getLocations",
      filterModelos: "getStatusFilterModelos"
    }),
    development() {
      return {id: this.id, level: this.levelId};
    },
    img() {
      const privada = this.$route.params.privada;
      const privadaSeleccionada = this.privadas[privada];
      console.log("este es la img ", privadaSeleccionada)
      return privadaSeleccionada;
    },
    amountAvailables() {
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.status == 2
      );
      return newArrfiltered;
    },
    rangeFilter(){
      console.log("id necesario", this.$route.params.id) 
      let selectRangeFileter
      if(this.$route.params.id == 177){
        selectRangeFileter = this.rangeFilterPriv5
      }else if(this.$route.params.id == 197){
        selectRangeFileter = this.rangeFilterPriv6
      }else if(this.$route.params.id == 198){
        selectRangeFileter = this.rangeFilterPriv7
      }else if(this.$route.params.id == 153){
        selectRangeFileter = this.rangeFilterPriv8
      }else if(this.$route.params.id == 150){
        selectRangeFileter = this.rangeFilterPriv1
      }else if(this.$route.params.id == 176 ){
        selectRangeFileter = this.rangeFilterPriv1
      }
      return  selectRangeFileter;
    },
    rangeSliderFilter(){
      let selectRangeFileter
      if(this.$route.params.id == 177){
        selectRangeFileter = this.rangeSliderFilterPriv5
      }else if(this.$route.params.id == 197){
        selectRangeFileter = this.rangeSliderFilterPriv6
      }else if(this.$route.params.id == 198){
        selectRangeFileter = this.rangeSliderFilterPriv7
      }else if(this.$route.params.id == 153){
        selectRangeFileter = this.rangeSliderFilterPriv8
      }else if(this.$route.params.id == 150){
        selectRangeFileter = this.rangeSliderFilterPriv1
      }else if(this.$route.params.id == 176){
        selectRangeFileter = this.rangeSliderFilterPriv4
      }
      return  selectRangeFileter;
    },
    rangeFilterPrice(){
      let selectRangeFileter
      if(this.$route.params.id == 177){
        selectRangeFileter = this.rangeFilterPricePriv5
      }else if(this.$route.params.id == 197){
        selectRangeFileter = this.rangeFilterPricePriv6
      }else if(this.$route.params.id == 198){
        selectRangeFileter = this.rangeFilterPricePriv7
      }else if(this.$route.params.id == 153){
        selectRangeFileter = this.rangeFilterPricePriv8
      }else if(this.$route.params.id == 150){
        selectRangeFileter = this.rangeFilterPricePriv1
      }else if(this.$route.params.id == 176){
        selectRangeFileter = this.rangeFilterPricePriv4
      }
      return  selectRangeFileter;
    },
    existFilter() {
      let arrExistFilter;
      if (this.rangeFilter) {
        arrExistFilter = this.arrFilteredLocations;
      } else if (this.rangeFilter === false) {
        arrExistFilter = this.locations;
      }
     
      return arrExistFilter;
    },
  },
  methods: {
    ...mapActions(["getAvailableLocations", "clearCoords"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },

  },
  async created() {
    await this.getAvailableLocations(this.development);
  },
  async beforeDestroy() {
    await this.clearCoords();
  },
  mounted() {
    
  }
};
</script>
